export const DOMAIN = 'Domain'
export const COVERAGE = 'Coverage'
export const COVERAGECOLLECTION = COVERAGE + 'Collection'

const COVJSON_NS = 'http://covjson.org/def/core#'

export const COVJSON_DATATYPE_TUPLE = COVJSON_NS + 'tuple'
export const COVJSON_DATATYPE_POLYGON = COVJSON_NS + 'polygon'
